import { render, staticRenderFns } from "./Add-user.vue?vue&type=template&id=35671a8f"
import script from "./Add-user.vue?vue&type=script&lang=js"
export * from "./Add-user.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports